export default "__VITE_ASSET__f56fca9c__"